import * as LucideIcons from "lucide-react";
import React from "react";
import { toDirectMediaUrl } from "../../lib/media";

export const RenderIcon: React.FC<{ icon: string }> = ({ icon }) => {
  // Try to get a Lucide icon
  const IconComponent = (LucideIcons as any)[icon];

  // Case 1: Lucide icon found
  if (IconComponent) {
    return <IconComponent className="w-8 h-8 text-white" />;
  }

  // Case 2: image — a local path or a remote URL. Test the path without its
  // query string, since a Dropbox link ends in "?raw=1", not ".webp".
  const path = icon.split("?")[0];
  if (/^https?:\/\//i.test(icon) || /\.(png|jpg|jpeg|svg|webp|gif)$/i.test(path)) {
    return (
      <img
        src={toDirectMediaUrl(icon)}
        alt="icon"
        className="w-8 h-8 object-contain"
      />
    );
  }

  // Case 3: fallback to emoji or text
  return <span className="text-2xl">{icon}</span>;
};
